import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import {pushPaymentSubmitAction} from '../../helpers/gtm';

const PaymentFormFooter = function (props) {
  const {
    confirmButton,
    confirmationInfo,
    onClick,
    noticeLogos,
    securePaymentText,
    formId
  } = props;

  const onSubmitClick = function () {
    pushPaymentSubmitAction('bottom');
  }

  return (
    <div>
      <div className="form-actions">
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
        <div
          className="terms-and-conditions"
          role="link"
          tabIndex={0}
          onClick={onClick}
        >
          {ReactHtmlParser(confirmationInfo)}
        </div>
        <button type="submit" form={formId} className="form-submit" onClick={onSubmitClick}>
          {confirmButton}
        </button>
        {securePaymentText && (
          <div className="security-payment">
            <p>
              {securePaymentText}
            </p>
          </div>
        )}
      </div>
      <div className="notice-logos">
        <img src={noticeLogos} alt="Notice logos" />
      </div>
    </div>
  )
}

export default PaymentFormFooter
